import { createRoute } from '@tanstack/react-router';
import { rootRoute } from '@trashlab/sitesapp/src/routes/__root';
import { JunkRemovalHeroSection } from '@trashlab/sitesapp/src/organizations/redebins/template/components/junk-removal/junk-removal-hero-section';
import { JunkRemovalContent } from '@trashlab/sitesapp/src/organizations/redebins/template/components/junk-removal/junk-removal-content';
import { ReadyWhenYouAre } from '@trashlab/sitesapp/src/organizations/redebins/template/components/shared/ready-when-you-are';
import { ServiceAreasSection } from '@trashlab/sitesapp/src/organizations/redebins/template/components/shared/service-areas-section';

const JunkRemovalPage = () => {
  return (
    <>
      <JunkRemovalHeroSection />
      <JunkRemovalContent />
      <ReadyWhenYouAre />
      <ServiceAreasSection />
    </>
  );
};

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/junk-removal',
  component: JunkRemovalPage,
});

